if ( ! customElements.get('main-header') ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			// Used to abort all document/window listeners when the element is removed.
			this._abortController = new AbortController();
			this.mount();
		}

		disconnectedCallback(){
			this._abortController?.abort();
			if ( this._rootVarsFrame ) {
				cancelAnimationFrame(this._rootVarsFrame);
				this._rootVarsFrame = 0;
			}
		}

		mount(){

			/* -- > DRAWERS < -- */

			// Every section wrapper, whatever its tag (the article section renders an <article>)
			document.querySelectorAll('#main > .shopify-section').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header';

				if ( this.classList.contains('site-header--style-one-row') ) {
					stickyHeader.innerHTML =
					`
					<div style="padding:10px;margin: 10px auto 0 auto;z-index: 1002;" class="site-header">
						<div style="padding:0!important;" class="container--large">
							<div class="${this.querySelector('.header__top').className }">
								${this.querySelector('.header__top').innerHTML}
							</div>
						</div>
					</div>
					`;
					stickyHeader.className = `sticky-header ${this.className}`;
					stickyHeader.classList.remove('site-header--absolute');

				} else {
					stickyHeader.innerHTML = `<div style="padding:0!important;" class="header__bottom header-container container--large portable-hide">
						${this.querySelector('.header__bottom').innerHTML}
						<div style="display:flex;gap:15px;">
							${this.querySelector('.area--custom-icon') ? this.querySelector('.area--custom-icon').outerHTML : ''}
							${this.querySelector('.area--search').outerHTML}
							${this.querySelector('.area--account') ? this.querySelector('.area--account').outerHTML : ''}
							${this.querySelector('.area--cart').outerHTML}
						</div>
					</div>
					<div class="site-header element--hide-on-portable-plus">
						${this.querySelector('.header-container--top').innerHTML}
					</div>`;
					
				}
				stickyHeader.classList.remove('site-header');
				document.body.append(stickyHeader);
				
				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('.site-nav [aria-controls]').forEach(elm=>{
					elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
				});

				window.lst = window.scrollY;
				window.lhp = 0;

				const mainHeader = this;
				const showSticky = () => {
					stickyHeader.classList.add('show');
					document.body.classList.add('sticky-header-shown');
				};
				const hideSticky = () => {
					stickyHeader.classList.remove('show');
					document.body.classList.remove('sticky-header-shown');
				};

				this.SCROLL_StickyHelper = () => {

					if ( document.body.classList.contains('menu-sidebar-opened') ) return;

					var st = window.scrollY;
					const stickyShown = stickyHeader.classList.contains('show');
					// offsetHeight (not getBoundingClientRect) so we get the height
					// the sticky-header would occupy when shown, even while it's
					// translated off-screen.
					const stickyTargetBottom = stickyHeader.offsetHeight;
					const mainHeaderStillVisible = mainHeader.getBoundingClientRect().bottom >= stickyTargetBottom;

					// While the in-flow main-header is still on-screen (its bottom
					// is at or past where the sticky-header's bottom would sit),
					// the sticky must stay hidden — otherwise the two headers
					// overlap, and re-showing it on the next scroll-up tick causes
					// rapid show/hide flicker around the swap-over point.
					if ( st <= 0 || mainHeaderStillVisible ) {
						if ( stickyShown ) {
							hideSticky();
							updateRootVars();
						}
						window.lst = st;
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;

					if ( st > window.lhp ) {

						if ( st <= lst && ! stickyShown ) {

							window.lhp = stickyHeader.offsetTop;
							showSticky();
							updateRootVars();

						} else if ( st > lst && stickyShown ) {
							hideSticky();
							updateRootVars();
						}

					}

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, { passive: true, signal: this._abortController.signal });
				
			}

			// drawer connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					const nativeControl = elm.matches('button, [href]');
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( elmSidebar._opened ) {
							elmSidebar.hide();
						} else {
							elmSidebar.show();
						}
					})
					// Keyboard opens only a closed drawer, then show() moves focus inside. The
					// href-less cart trigger gets no click from keys: Enter opens it here, Space on keyup.
					elm.addEventListener('keydown', e=>{
						const space = e.key === ' ' && ! nativeControl;
						if ( ( e.key !== 'Enter' && ! space ) || elmSidebar._opened ) return;
						elmSidebar._focusOnOpen = true;
						if ( space ) {
							e.preventDefault();
						} else if ( ! nativeControl ) {
							e.preventDefault();
							elmSidebar.show();
						}
					})
					elm.addEventListener('keyup', e=>{
						if ( e.key === ' ' && ! nativeControl && elmSidebar._focusOnOpen && ! elmSidebar._opened ) {
							elmSidebar.show();
						}
					})
				}
			});
			if ( this.classList.contains('site-header--alignment-left') || this.classList.contains('site-header--style-one-row') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}
			if ( this.classList.contains('site-header--style-one-row') && this.classList.contains('site-header--alignment-center') ) {
				document.getElementById('site-menu-sidebar').classList.remove('sidebar--right');
				document.getElementById('site-menu-sidebar').classList.add('sidebar--left');
			}
			
			// closing drawers

			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			// The menu drawer opts out of .site-overlay (assets/section-header.css) and
			// uses its own transparent scrim instead, so give that one the same
			// tap-to-close behaviour. Guarding on _opened matches how the burger
			// toggle above reads state.
			this.parentElement?.querySelector('[data-js-menu-scrim]')?.addEventListener('click', ()=>{
				const menuSidebar = document.getElementById('site-menu-sidebar');
				if ( menuSidebar?._opened ) menuSidebar.hide();
			}, { signal: this._abortController.signal });
			document.addEventListener('keydown', e=>{
				if ( e.keyCode === window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			}, { signal: this._abortController.signal });

			// resizing drawers

			const getHeaderHeight = () => {
				const sticky = document.querySelector('.sticky-header.show');
				if ( sticky ) return Math.round(sticky.getBoundingClientRect().bottom);
				const el = document.querySelector('main-header');
				if ( !el ) return 0;
				return Math.round(el.getBoundingClientRect().bottom);
			};
			// First candidate with a box, NOT the first in document order. The
			// two-rows sticky clone holds two `.site-header` nodes and the one that
			// is display:none from 1024px up (element--hide-on-portable-plus,
			// assets/theme.css:1511) comes first — measuring it wrote
			// --header-width/--header-left as 0px and collapsed the drawer.
			// rect.width, not offsetWidth: offsetWidth would force a second
			// synchronous layout on the same element on every resize.
			const pickHeaderRect = (selector) => {
				for ( const node of document.querySelectorAll(selector) ) {
					const rect = node.getBoundingClientRect();
					if ( rect.width > 0 ) return rect;
				}
				return null;
			};
			const getHeaderMetrics = () => {
				// Must measure the SAME element getHeaderHeight() does. That prefers
				// the sticky bar when it is shown, and the sticky bar is inset by
				// --gutter-container (section-header.css:1118) — so always measuring
				// the in-flow header here made the drawer wider than the bar it
				// hangs from. The clone's outer wrapper has `site-header` stripped
				// when it is built, so this targets its inner card.
				const rect = pickHeaderRect('.sticky-header.show .site-header')
					|| pickHeaderRect('.site-header');
				if ( !rect ) return { width: document.body.clientWidth, left: 0 };
				return { width: Math.round(rect.width), left: rect.left };
			};
			// setProperty rather than rewriting #root-height's innerHTML: this runs
			// once per animation frame while a window edge is dragged, and replacing
			// a <style> element's text invalidates and reparses the document's style
			// rules every time. The :root { --window-height: 100vh } default in
			// snippets/head-variables.liquid:250 stays as the pre-JS fallback — these
			// inline values on <html> win over it.
			const updateRootVars = () => {
				const hm = getHeaderMetrics();
				const rootStyle = document.documentElement.style;
				rootStyle.setProperty('--window-height', `${window.innerHeight}px`);
				rootStyle.setProperty('--window-width', `${document.body.clientWidth}px`);
				rootStyle.setProperty('--header-height', `${getHeaderHeight()}px`);
				rootStyle.setProperty('--header-width', `${hm.width}px`);
				rootStyle.setProperty('--header-left', `${hm.left}px`);
			};
			window.updateHeaderRootVars = updateRootVars;

			// rAF throttle, NOT a trailing debounce. The vars below drive the
			// drawer's width/left as a pixel snapshot, and `debounce` in
			// layout/theme.liquid:60 is trailing-edge only — every call clears and
			// reschedules the timer. While a window edge is dragged, `resize` fires
			// every frame, so the timer never expires for the whole drag and the
			// drawer stays frozen at its start-of-drag width while the header,
			// being pure CSS, re-lays out every frame. One update per frame keeps
			// them in step. Keep this property name: unmount() removes the listener
			// by reference.
			// Handle on the instance, not a closure local, so disconnectedCallback
			// can cancel a frame that is still queued — aborting the controller
			// removes the listener but would let one last callback run.
			this._rootVarsFrame = 0;
			this.RESIZE_SidebarHelper = () => {
				if ( this._rootVarsFrame ) return;
				this._rootVarsFrame = requestAnimationFrame(()=>{
					this._rootVarsFrame = 0;
					updateRootVars();
				});
			};
			window.addEventListener('resize', this.RESIZE_SidebarHelper, { signal: this._abortController.signal });
			updateRootVars();
			document.body.classList.add('header-loaded');

			// switch menu (on load and on resize)
			this._previousWidth = window.innerWidth;
			this._checkMenuWidth();
			this._checkMenuWidth();

			window.addEventListener('resize', debounce(()=>{
				const currentWidth = window.innerWidth;
				if ( currentWidth < this._previousWidth ) {
					this._checkMenuWidth();
				} else if ( this._menuCollapsedAt && currentWidth > this._menuCollapsedAt ) {
					// Wide enough for the nav's measured shortfall to have been made up
					// (see _checkMenuWidth), so it should fit again. Restore first —
					// offsetWidth is 0 while hidden, so the fit maths in
					// _checkMenuWidth can't be trusted until display is back — then
					// re-check in case it still doesn't.
					if ( this._restoreClassicMenu() ) this._checkMenuWidth();
				}
				this._previousWidth = currentWidth;
			}, 200), { signal: this._abortController.signal });

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer]').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {

				this.querySelector('search-form').addEventListener('click', e=>{
					e.preventDefault();
					window.location.href = KROWN.settings.routes.search_url;
				});

			}

			// touch menu helpers

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			if ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) {
				document.querySelectorAll('.style--classic .has-babymenu > a').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					elmLink.addEventListener('click', e=>{
						e.preventDefault();
						e.stopPropagation();
						elm.classList.toggle('focus');
						babyMenuTouch = true;
						closeTouchSubmenus(elm,elm.closest('.has-submenu'));
					})
				})
				document.querySelectorAll('.style--classic .has-submenu > a, .style--classic .has-submenu > button.menu-link').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					if ( ! elm.classList.contains('mega-link') ) {
						elmLink.addEventListener('click', e=>{
							e.preventDefault();
							e.stopPropagation();
							if ( ! babyMenuTouch ) {
								elm.classList.toggle('focus');
								closeTouchSubmenus(elm);
							}
							babyMenuTouch = false;
						})
					}
				});
			}

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a, .site-nav.style--classic .has-submenu > button.menu-link').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			window.removeEventListener('scroll', this.SCROLL_StickyHelper);
			document.querySelector('.sticky-header')?.remove();
		}

		_checkMenuWidth() {
			
			const header = document.querySelector('.site-header--menu-classic');
			if ( !header ) {
				return;
			}

			const classicMenu = header.querySelector('.area--menu-classic');
			if ( !classicMenu ) {
				return;
			}
			
			const logo = header.querySelector('.area--logo');
			const logoIsCentered = header.classList.contains('header__top--logo-center');
			let availWidthforClassicMenu = 0;

			const headerStyle = window.getComputedStyle(header);
			const headerPaddingRight = parseFloat(headerStyle.getPropertyValue('padding-right'));
		  const headerPaddingLeft = parseFloat(headerStyle.getPropertyValue('padding-left'));
		  const headerRowGap = 10;

			const headerWidth = header.offsetWidth - headerPaddingLeft - headerPaddingRight;
			const logoWidth = logo.offsetWidth;
			const classicMenuWidth = classicMenu.offsetWidth + headerRowGap;
			
			const headerItems = header.children;
		
			// Calculate the total width of the child elements
			let totalWidthOfHeaderItems = 0;
			for (let i = 0; i < headerItems.length; i++) {
				if(headerItems[i].offsetWidth > 0) {
					totalWidthOfHeaderItems += headerItems[i].offsetWidth + headerRowGap;
				}
			}

			totalWidthOfHeaderItems -= headerRowGap; // grid gap for one element (gap is inner space :) )

			if( logoIsCentered ) {
				availWidthforClassicMenu = headerWidth / 2 - logoWidth / 2 - headerRowGap; // consider the gap
			} else {
				let otherElementsWidth = totalWidthOfHeaderItems - logoWidth - classicMenuWidth;
				availWidthforClassicMenu = headerWidth - otherElementsWidth - logoWidth;
			}

			// If no available space for classic menu, convert menu to minimal.
			// Hidden, NOT removed: removing it meant widening the window could
			// never bring the nav back — this function early-returns when
			// .area--menu-classic is missing, so once gone it was gone until a
			// reload. Record the width it collapsed at so the resize handler knows
			// when it is safe to restore.
			if ( classicMenuWidth > availWidthforClassicMenu ) {
				header.classList.remove('site-header--menu-classic');
				header.classList.add('site-header--menu-minimal');
				classicMenu.style.display = 'none';
				// Store the width the nav would need, not the width it collapsed at.
				// The bare innerWidth made the resize handler restore at +1px — a
				// width that by definition still doesn't fit — so every 200ms tick of
				// a widening drag flashed the classic nav in and straight back out,
				// each cycle re-running the offsetWidth loop above.
				this._menuCollapsedAt = window.innerWidth
					+ Math.ceil(classicMenuWidth - availWidthforClassicMenu);
			}
		}

		// Reverse of the collapse branch above. Queries the minimal class because
		// the classic one is gone while collapsed.
		_restoreClassicMenu() {
			const header = document.querySelector('.site-header--menu-minimal');
			if ( !header ) return false;

			const classicMenu = header.querySelector('.area--menu-classic');
			if ( !classicMenu ) return false;

			header.classList.remove('site-header--menu-minimal');
			header.classList.add('site-header--menu-classic');
			classicMenu.style.display = '';
			this._menuCollapsedAt = null;
			return true;
		}

		_adjustNavLayout() {
			if ( this.querySelector('.site-nav') && this.querySelector('.site-nav').classList.contains('style--classic') ) {

				if ( this.querySelector('nav > ul').scrollWidth > this.querySelector('nav').offsetWidth ) {
					this.classList.add('site-header--swap-menu-style');
					document.body.classList.remove('header--has-two-rows');
					let header = document.getElementById('site-header');
					let twoRowsDetected = header.querySelectorAll('[class*="two-rows"]');
					twoRowsDetected.forEach(el=>{
						el.className = el.className.replace('two-rows', 'one-row');
					});
				}
			}
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( ! customElements.get('sidebar-drawer') ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this._abortController = new AbortController();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode === window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			}, { signal: this._abortController.signal });
		}

		disconnectedCallback(){
			this._abortController?.abort();
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			// Cancel a close scheduled less than 501ms ago. It would otherwise
			// fire mid-open and leave this element display:none while _opened is
			// true — the burger reads _opened (:145), so its next tap runs hide()
			// and appears to do nothing, with the page still scroll-locked and
			// inert. Repeated open/close taps hit this every time.
			clearTimeout(this._hideTimer);
			// A show() repeated within 15ms keeps one timer, so none can fire after a hide().
			clearTimeout(this._showTimer);
			const opening = ! this._opened;

			// Remember the opener once per opening. An opener inside the menu that hands
			// over to this drawer is about to disappear, so keep the menu's opener instead.
			const menuSidebar = this.id !== 'site-menu-sidebar' ? document.getElementById('site-menu-sidebar') : null;
			if ( opening ) {
				let opener = document.activeElement;
				if ( menuSidebar?._opened && menuSidebar.contains(opener) ) opener = menuSidebar._opener;
				this._opener = opener && opener !== document.body ? opener : null;
			}
			if ( menuSidebar?._opened ) menuSidebar.hide({ restoreFocus: false });

			this._opened = true;
			document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach(btn => btn.setAttribute('aria-expanded', 'true'));
			OrdoUtils.lockScroll('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id === 'site-menu-sidebar' ) {
				document.body.classList.add('menu-sidebar-opened');
				// Measure after scroll lock so scrollbar is gone and site-header
				// is already at its full expanded width before the transition starts.
				if ( typeof window.updateHeaderRootVars === 'function' ) {
					window.updateHeaderRootVars();
				}
			}
			// Recommendations load on opening; a drawer that's already open keeps its list (an app's refreshCart, an add from inside it).
			if ( opening && this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				document.getElementById('cart-recommendations-sidebar').generateRecommendations?.();
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}
			this.style.display = 'grid';
			const isMenuSidebar = this.id === 'site-menu-sidebar';
			const mainHeaderSection = isMenuSidebar ? document.querySelector('main-header')?.closest('[data-js-inert]') : null;
			this._showTimer = setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					if ( elm === mainHeaderSection ) return;
					elm.setAttribute('inert', '');
				})
				const moveFocus = this._focusOnOpen || this.id === 'site-filters-sidebar' || this.id === 'site-availability-sidebar';
				this._focusOnOpen = false;
				if ( moveFocus && ! this.contains(document.activeElement) ) {
					this.querySelector('[data-js-close]')?.focus();
				}
			}, 15);

		}

		hide({ restoreFocus = true } = {}){

			// Cancel a show scheduled less than 15ms ago. That callback re-adds
			// `sidebar--opened` AND re-applies inert to every section, so left to
			// run after a hide it would leave the whole page unclickable.
			clearTimeout(this._showTimer);

			// Already closed or closing: nothing to undo.
			if ( ! this._opened ) return;

			this._opened = false;
			this.classList.remove('sidebar--opened');

			OrdoUtils.unlockScroll('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			document.body.classList.remove('menu-sidebar-opened');
			// Scrollbar has reappeared — re-measure so sidebar width matches nav
			// during the close animation.
			if ( this.id === 'site-menu-sidebar' && typeof window.updateHeaderRootVars === 'function' ) {
				window.updateHeaderRootVars();
			}
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			});

			const controls = [...document.querySelectorAll(`[aria-controls="${this.id}"]`)];
			controls.forEach(btn => btn.setAttribute('aria-expanded', 'false'));

			// Return focus to the opener once inert is gone. A re-rendered or hidden opener (the sticky clone hides again)
			// falls back to a visible control for this drawer, but only while focus is in the drawer: a mouse close with no
			// opener recorded (Safari doesn't focus a clicked button, or an app opened it) leaves focus where it is.
			const visible = el => el && el.isConnected && ( el.checkVisibility ? el.checkVisibility({ checkVisibilityCSS: true, visibilityProperty: true }) : el.getClientRects().length > 0 );
			const opener = visible(this._opener) ? this._opener : ( this.contains(document.activeElement) ? controls.find(visible) : null );
			this._opener = null;
			this._focusOnOpen = false;
			if ( restoreFocus && opener ) opener.focus({ preventScroll: true });

			clearTimeout(this._hideTimer);
			this._hideTimer = setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( ! customElements.get('mobile-navigation') ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a, .has-submenu > button.menu-link').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a, .submenu-back button').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

		}

		_resizeContainer(main=false){
			if ( main ) {
				this.style.height = `auto`;
			} else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
			}
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}